import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MenuButtonMode, MENU_BUTTON_MODE } from './model/menu-button-mode.model';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sibat-menu-button',
  template: `
    <button
      class="menu-button"
      data-testid="menu-button"
      [class.edition-left-border]="mode === menuButtonModes.edition && !disabled"
      [class.selection-left-border]="mode === menuButtonModes.selection && !disabled"
      [class.disabled-left-border]="disabled"
      [disabled]="disabled"
      (click)="clicked.emit()"
    >
      {{ title }}
      <div>
        @switch (mode) { @case (menuButtonModes.edition) {
        <mat-icon data-testid="edition-icon" [class.edition-color]="!disabled">edit</mat-icon>
        } @case (menuButtonModes.selection) {
        <mat-icon data-testid="selection-icon" [class.selection-color]="!disabled">add</mat-icon>
        } }
      </div>
    </button>
  `,
  styleUrls: ['menu-button.component.scss'],
  imports: [MatIcon],
})
export class MenuButtonComponent {
  @Output() clicked = new EventEmitter<void>();

  @Input() title: string;
  @Input() disabled: boolean;
  @Input() mode: MenuButtonMode;

  menuButtonModes = MENU_BUTTON_MODE;
}
